import React, { useState ,useEffect} from "react";
import axios from "axios";

const TableFourA = props => {
  const API = props.API;
  const [N, setN] = useState([0, 0, 0]);
  const [N1, setN1] = useState([0, 0, 0]);
  const [N2, setN2] = useState([0, 0, 0]);
  const [N3, setN3] = useState([0, 0, 0]);
  const [editable, setEditable] = useState(false);

  const submitForm = data => {
    var settings = {
      url: API + "/sectionfoura-create",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        n: data.n,
        n1: data.n2,
        n2: data.n2,
        n3: data.n3,
        tn4 : data.tn4

      }
    };

    axios(settings)
      .then(res => {
        console.log("Database Stored");
        console.log(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    var settings = {
      url: API + "/sectionfoura-get",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };

    axios(settings)
      .then(res => {
        let n = res.data.n;
        let n1 = res.data.n1;
        let n2 = res.data.n2;
        let n3 = res.data.n3;
        n.length === 0 ? setN([0, 0, 0]) : setN(n);
        n1.length === 0 ? setN1([0, 0, 0]) : setN1(n1);
        n2.length === 0 ? setN2([0, 0, 0]) : setN2(n2);
        n3.length === 0 ? setN3([0, 0, 0]) : setN3(n3);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);


  const changeData = (type, val, index, previousData) => {
    val = Number(val);

    switch (type) {
      case "N":
        if (index === 0) setN([val, previousData[1], previousData[2]]);
        if (index === 1) setN([previousData[0], val, previousData[2]]);
        if (index === 2) setN([previousData[0], previousData[1], val]);
        break;
      case "N1":
        if (index === 0) setN1([val, previousData[1], previousData[2]]);
        if (index === 1) setN1([previousData[0], val, previousData[2]]);
        if (index === 2) setN1([previousData[0], previousData[1], val]);
        break;
      case "N2":
        if (index === 0) setN2([val, previousData[1], previousData[2]]);
        if (index === 1) setN2([previousData[0], val, previousData[2]]);
        if (index === 2) setN2([previousData[0], previousData[1], val]);
        break;
      case "N3":
        if (index === 0) setN3([val, previousData[1], previousData[2]]);
        if (index === 1) setN3([previousData[0], val, previousData[2]]);
        if (index === 2) setN3([previousData[0], previousData[1], val]);
        break;
      default:
        console.log("Default");
    }
  };

  return (
    <div>
      <h2>Table 4A</h2>
      <table border="1" cellPadding="10" width="80%">
        <tbody>
          {/* Heading */}
          <tr>
            <th>
              Item <br />
              (Information to be provided cumulatively for all the shifts with
              explicit headings, wherever applicable)
            </th>
            <th>
              CAY <br /> (2017-2018)
            </th>
            <th>
              CAYm1 <br /> (2016-2017)
            </th>
            <th>
              CAYm2 <br /> (2015-2016)
            </th>
          </tr>

          {/* N */}
          <tr>
            <td>Sanctioned intake of the program (N)</td>
            {N.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("N", e.target.value, index, [
                          N[0],
                          N[1],
                          N[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* N1 */}
          <tr>
            <td>
              Total number of students admitted in first year minus number of
              students migrated to other programs/institutions plus no. of
              students migrated to this program (N1)
            </td>
            {N1.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("N1", e.target.value, index, [
                          N1[0],
                          N1[1],
                          N1[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* N2 */}
          <tr>
            <td>
              Number of students admitted in 2nd year in the same batch via
              lateral entry (N2)
            </td>
            {N2.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("N2", e.target.value, index, [
                          N2[0],
                          N2[1],
                          N2[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* N3 */}
          <tr>
            <td>Separate division students, if applicable (N3)</td>
            {N3.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("N3", e.target.value, index, [
                          N3[0],
                          N3[1],
                          N3[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>
          <tr>
            <td>
              Total number of students admitted in the Program (N1 + N2 + N3)
            </td>

            <td>{Number(N1[0]) + Number(N2[0]) + Number(N3[0])}</td>
            <td>{Number(N1[1]) + Number(N2[1]) + Number(N3[1])}</td>
            <td>{Number(N1[2]) + Number(N2[2]) + Number(N3[2])}</td>
          </tr>
        </tbody>
      </table>
      <p>
        <b>CAY</b> – Current Academic Year <br />
        <b> CAY</b>- Current Academic Year minus1= Current Assessment Year
        <br />
        <b> CAY</b> - Current Academic Year minus2=Current Assessment Year minus
        1 <br />
        <b> LYG</b> - Last Year Graduate <br />
        <b> LYGm1</b> – Last Year Graduate minus 1 <br />
        <b>LYGm2</b> – Last Year Graduate minus 2 <br />
      </p>
      {editable ? null : (
        <button onClick={() => setEditable(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditable(false);

          var data = {
            n : N,
            n1 : N1,
            n2 : N2,
            n3 : N3,
            tn4: [
              Number(N1[0]) + Number(N2[0]) + Number(N3[0]),
              Number(N1[1]) + Number(N2[1]) + Number(N3[1]),
              Number(N1[2]) + Number(N2[2]) + Number(N3[2])
            ]
          };
          console.log(data);
          submitForm(data);
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default TableFourA;
